export const startInit = 'REMOTE_CONFIG_START';
export const initConfig = 'REMOTE_CONFIG_INITIALIZE';
export const dataRequest = 'REMOTE_CONFIG_DATA_REQUEST';
export const dataUpdate = 'REMOTE_CONFIG_DATA_UPDATE';

export const dataComplete = 'REMOTE_CONFIG_DATA_COMPLETE';
